import { useNutrientList } from 'context/Store';
import { useTranslation } from 'react-i18next';

import { ProductTableItem } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ProductTableItem';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import * as ProductList from 'types/Recipe/Detail/ErpNew/ProductList';
import * as Nutrient from 'types/_general/Store/Nutrient';
import * as NutrientList from 'types/_general/Store/NutrientList';

export const ProductTable = (
	props: RecipeErpViewComponentProps & {
		productList: ProductList.Type;
		ingredientId: string;
		segmentIndex: number;
		isLoaded: boolean;
	}
) => {
	const { t } = useTranslation();
	const nutrients = useNutrientList();

	if (!props.productList.length && props.isLoaded) return <em>No Products</em>;

	return (
		<>
			<RenderIf condition={!props.isLoaded}>
				<LoadingSpinner />
			</RenderIf>
			<RenderIf condition={props.isLoaded}>
				<div className="table-responsive">
					<table className="table table-sm table-bordered " style={{ marginBottom: '0' }}>
						<thead>
							<tr>
								<th style={getTdWidth(40)}></th>
								<th>{t('_general:IMAGE')}</th>
								<th style={getTdWidth(140)}>{t('_general:BRAND')}</th>
								<th style={getTdWidth(220)}>{t('_general:PRODUCT_NAME')}</th>
								<th style={getTdWidth(120)}>{t('recipe:PRICE')}</th>
								<th>GTIN</th>
								{props.state.selectedColumns.map((e, i) => {
									return (
										<th key={i}>
											{Nutrient.toString(NutrientList.getById(nutrients, e))}
										</th>
									);
								})}
							</tr>
						</thead>
						<tbody>
							{props.productList.map((e, i) => {
								return (
									<ProductTableItem
										key={i}
										{...props}
										product={e}
										ingredientId={props.ingredientId}
										segmentIndex={props.segmentIndex}
									/>
								);
							})}
						</tbody>
					</table>
				</div>
			</RenderIf>
		</>
	);
};

function getTdWidth(input: number): React.CSSProperties {
	return {
		width: `${input}px`,
		minWidth: `${input}px`,
	};
}
